import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Visita/addVisita`, method: 'POST', body: values, token: token})
}
